<template>
  <div v-if="!hidden" class="alert-wrapper" :style="colorStyle">
    <div class="d-flex flex-row gap-2 pa-4 align-start justify-space-between alert">
      <div class="d-flex flex-row align-start gap-2">
        <v-icon v-if="computedIcon" :color="computedColor"> {{ computedIcon }} </v-icon>
        <span>
          <slot />
        </span>
      </div>
      <v-btn v-if="dismissible" icon @click="hidden = true">
        <v-icon> mdi-close </v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
import { Prop, Computed } from '@/_typedefs'
export default {
  props: {
    /** @type {Prop<'info' | 'custom'>} */
    type: {
      type: String,
      required: true,
    },
    color: {
      type: String,
    },
    icon: {
      type: String,
    },
    dismissible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      hidden: false,
    }
  },
  computed: {
    /** @type {Computed<string?>} */
    computedIcon() {
      const iconMap = {
        info: 'mdi-information',
      }

      return this.icon || iconMap[this.type] || null
    },
    /** @type {Computed<string?>} */
    computedColor() {
      const colorTypeMap = {
        info: '#938F99',
      }

      return this.color || colorTypeMap[this.type] || '#000'
    },
    /** @type {Computed<Record<string, string>>} */
    colorStyle() {
      return {
        color: this.computedColor,
        '--accent-color': this.computedColor,
      }
    },
  },
}
</script>

<style scoped>
.alert {
  border: 2px solid var(--accent-color);
  border-left-width: 8px;
  border-radius: 8px;
  position: relative;
  z-index: 2;
}
.alert-wrapper {
  position: relative;
  background-color: #fff;
}
.alert-wrapper::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: var(--accent-color);
  opacity: 0.1;
  z-index: 1;
}
</style>
